/* eslint-disable no-unneeded-ternary */

import AppBar from '@material-ui/core/AppBar'
import { withStyles } from '@material-ui/core/styles'

// We can inject some CSS into the DOM.

const styles = theme => ({
  appBar: {
    color: `var(--gameday-body-textColorAlt, ${theme.body.textColorAlt})`,
    background: 'transparent',
    display: 'inline-flux',
    width: 'auto',
    boxShadow: 'none',
    borderRadius: '5px',
    '& button': {
      border: '1px solid #ccc',
    },
    '& button:first-child': {
      borderTopLeftRadius: '5px',
      borderBottomLeftRadius: '5px',
    },
    '& button:last-child': {
      borderTopRightRadius: '5px',
      borderBottomRightRadius: '5px',
    },
    '& button:not(:first-child)': {
      marginLeft: '-1px',
    },
  },
})

function SecondaryAppBar({ position, style, classes, children }) {
  return (
    <AppBar position={position} style={style} className={classes.appBar}>
      {children ? children : ''}
    </AppBar>
  )
}

export default withStyles(styles)(SecondaryAppBar)
